import BodySimpleModalV3 from '../../../common/modal/BodySimpleModalV3'
import classes from './Box.module.css'

export default function ThisWeekGraphItem({overdue, due, completed}) {

    function calculatePercentage(value) {
        return (value / (overdue + due + completed)) * 100
    }

    return <div className={classes.item_graph} >
        {overdue ? <div className={`${classes.item_part} ${classes.item_part_overdue}`} style={{width: `${calculatePercentage(overdue)}%`}}>
            <BodySimpleModalV3 message={'Overdue tasks'}>
                <div className={classes.item_part_inner}>{overdue}</div> 
            </BodySimpleModalV3>
        </div> : null} 
        {due ? <div className={`${classes.item_part} ${classes.item_part_due}`} style={{width: `${calculatePercentage(due)}%`}}>
            <BodySimpleModalV3 message={'Due tasks'}>
                <div className={classes.item_part_inner}>{due}</div>
            </BodySimpleModalV3>
        </div> : null} 
        {completed ? <div className={`${classes.item_part} ${classes.item_part_completed}`} style={{width: `${calculatePercentage(completed)}%`}}>
            <BodySimpleModalV3 message={'Completed tasks'}>
                <div className={classes.item_part_inner}>{completed}</div>
            </BodySimpleModalV3>
        </div> : null} 
    </div>
}